import React, { ReactElement } from 'react';
import classNames from 'classnames';

import styles from './OutLink.module.scss';

export interface OutLinkProps {
  ariaLabel: string;
  children: ReactElement | string;
  handleClick?: () => void;
  size?: 'small' | 'medium';
  to: string;
}

export default function OutLink({
  ariaLabel,
  children,
  handleClick,
  size = 'small',
  to,
}: OutLinkProps) {
  return (
    <a
      aria-label={ariaLabel}
      className={classNames(styles.outlink, styles[size])}
      href={to}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
